import { gfLoopConditionalRules } from './gf-loop-conditional-rules.helpers'
import { GravityFormsAPIFieldProps } from '@typings'

export const gfGetFieldCurrentVisibility = (
  field: GravityFormsAPIFieldProps,
  fieldValues: any
) => {
  if (!field.conditionalLogic) return true
  const { hasRules, rulesAreMet } = gfLoopConditionalRules(
    field.conditionalLogic,
    fieldValues
  )
  if (!hasRules) return true
  if (rulesAreMet) return true
  return false
}
